import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../../shared-components/System';
import { YearService } from '../../../shared-components/year/year.service';
import { PermissionGroupDescription, PermissionGroupUsers, PermissionsGroupsAssignedToStaff, PermissionsList, WhoHasPermissions } from './permissions-groups.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionsGroupsService {

  constructor(
    private http: HttpClient,
    private yearService: YearService
  ) { }

  getPermissionGroupDescription(): Observable<PermissionGroupDescription[]> {
    return this.http.get<PermissionGroupDescription[]>(System.apiURL.Management + 'GetPermissionGroupDescription');
  }

  getAllUsersAssignedToPermissionsGroups(): Observable<PermissionGroupUsers[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id;
    return this.http.get<PermissionGroupUsers[]>(System.apiURL.Management + 'GetAllUsersAssignedToPermissionsGroups' + queryString);
  }

  isPermissionsGroupExists(permissionsGroupName: string, permissionsGroupId: number): Observable<boolean> {
    const queryString = '?permissionsGroupName=' + permissionsGroupName + '&permissionsGroupId=' + permissionsGroupId;
    return this.http.get<boolean>(System.apiURL.Management + 'IsPermissionsGroupExists' + queryString);
  }

  copyPermissionsGroup(copyFromGroupId: number, permissionsGroupName: string): Observable<boolean> {
    const queryString = '?copyFromGroupId=' + copyFromGroupId + '&permissionsGroupName=' + permissionsGroupName;
    return this.http.get<boolean>(System.apiURL.Management + 'CopyPermissionsGroup' + queryString);
  }

  copyPermissions(action: boolean, copyFromGroupId: number, copyToGroupIdList: number[]): Observable<boolean> {
    const queryString = '?action=' + action + '&copyFromGroupId=' + copyFromGroupId;
    return this.http.post<boolean>(System.apiURL.Management + 'CopyPermissions' + queryString, copyToGroupIdList);
  }

  deletePermissionsGroup(permissionsGroupId: number): Observable<boolean> {
    const queryString = '?permissionsGroupId=' + permissionsGroupId;
    return this.http.get<boolean>(System.apiURL.Management + 'DeletePermissionsGroup' + queryString);
  }

  getPermissionsList(permissionsGroupId: number): Observable<PermissionsList[]> {
    const queryString = '?permissionsGroupId=' + permissionsGroupId;
    return this.http.get<PermissionsList[]>(System.apiURL.Management + 'GetPermissionsList' + queryString);
  }

  savePermissionsGroup(permissionsGroupId: number, permissionsGroupName: string, permissionsList: PermissionsList[]): Observable<boolean> {
    const queryString = '?permissionsGroupId=' + permissionsGroupId + '&permissionsGroupName=' + permissionsGroupName;
    return this.http.post<boolean>(System.apiURL.Management + 'SavePermissionsGroup' + queryString, permissionsList);
  }

  getWhoHasPermissions(permissionAreaId: number, permissionName: string): Observable<WhoHasPermissions[]> {
    const queryString = '?permissionAreaId=' + permissionAreaId + '&permissionName=' + permissionName;
    return this.http.get<WhoHasPermissions[]>(System.apiURL.Management + 'GetWhoHasPermissions' + queryString);
  }

  getUserPermissions(permissionsGroupId: number, staffUserId: number, schoolId: number): Observable<PermissionsList[]> {
    const queryString = '?siteId=' + schoolId + '&permissionsGroupId=' + permissionsGroupId + '&staffUserId=' + staffUserId;
    return this.http.get<PermissionsList[]>(System.apiURL.Management + 'GetUserPermissions' + queryString);
  }

  saveUserPermissionsGroups(staffUserId: number, schoolId: number, permissionsGroups: PermissionGroupDescription[]): Observable<boolean> {
    const queryString = '?staffUserId=' + staffUserId + '&schoolId=' + schoolId;
    return this.http.post<boolean>(System.apiURL.Management + 'SaveUserPermissionsGroups' + queryString, permissionsGroups);
  }

  getPermissionsGroupsAssignedToStaffUser(staffUserId: number, schoolId: number, primaryGroupOnly: boolean): Observable<PermissionsGroupsAssignedToStaff[]> {
    const queryString = '?staffUserId=' + staffUserId + '&schoolId=' + schoolId + '&primaryGroupOnly=' + primaryGroupOnly;
    return this.http.get<PermissionsGroupsAssignedToStaff[]>(System.apiURL.Management + 'GetPermissionsGroupsAssignedToStaffUser' + queryString);
  }
}
